module.exports = __webpack_public_path__ + "img-front/google.20eead59.png";